export const OVERBOOKING_COMPENSATION_ID = 71636186;
export const OUR_FEES_ID = 142848538;
export const PRICE_LIST_ID = 52702007;
export const IMPRINT_ID = 52883090;
export const AIR_PAYOUT_ID = 234864063;
